var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rules-prizes",class:{ 'rules-prizes--center': _vm.center }},[_c('ul',{ref:"carousel",staticClass:"rules-prizes__list owl-carousel"},_vm._l((_vm.prizes),function(prize,i){return _c('li',{key:i,staticClass:"rules-prizes__item"},[_c('img',{staticClass:"rules-prizes__img",attrs:{"src":prize,"alt":""}})])})),_vm._v(" "),_c('div',{staticClass:"rules-prizes__btn"},[_vm._t("default")],2)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41fd95e0","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/containers/ContestPrizes/ContestPrizes.vue
// module id = null
// module chunks = 